/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/OldAction/Action/SecondaryAction/Letter/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let taskResources0DocumentTreeNodeNameValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources[0].document_tree_node.name',
})
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 weight="medium"
 color={dtColorsGreen700}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../../../../../OldLetter/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../../../../../OldLetter/Content'))}
 data="task.resources[0].document_tree_node.name"
 text={taskResources0DocumentTreeNodeNameValueData}
/>
{children}
</React.Fragment>)
}